import React from 'react';
import {Tabs, Tab} from 'material-ui/Tabs';
import ProfileSettings from '../components/ProfileSettings';
import PasswordSettings from '../components/PasswordSettings';
import PaymentsSettings from '../components/PaymentsSettings';
import PricingSettings from '../components/PricingSettings';
import {Switch, Route, withRouter, Redirect} from 'react-router-dom';
import {PASSWORD, PRICING, PAYMENTS, PROFILE} from 'constants/usersSettings';
import {inject} from 'mobx-react';

@withRouter
@inject('userStore')
@inject('examPrepHeaderStore')
export default class Profile extends React.Component {
  componentWillMount() {
    const {examPrepHeaderStore: {clear}} = this.props;
    clear();
    this.initTab(this.props.location);
    this.routerListener = this.props.history.listen((location) => {
      this.initTab(location);
    });
  }

  handleChange = (value) => {
    this.props.history.push(`/settings/${value}`);
  };

  initTab = location => {
    let value = location.pathname.split('/settings/')[1];
    if (![PASSWORD, PROFILE, PRICING, PAYMENTS].includes(value))
      value = PROFILE;

    this.state = {
      value: value
    };
  };

  componentWillUnmount(){
    this.routerListener();
  }

  render() {
    return (
      <div className="form-wrapper profile-wrapper">
        <div className="form-container">

          <div className="form-content col-4">
              <Tabs
                value={this.state.value}
                onChange={this.handleChange}
                inkBarStyle={{background: '#28b5f4'}}>
                <Tab label="Profile" value={PROFILE}/>
                <Tab label="Password " value={PASSWORD}/>
                <Tab label="Payments" value={PAYMENTS}/>
              </Tabs>
            <Switch>
              <Route path="/settings/profile" component={ProfileSettings} key="profile"/>
              {/* {this.props.userStore.user.valid_profile && */}
              [<Route path="/settings/password" component={PasswordSettings} key="password"/>,
                < Route path="/settings/payments" component={PaymentsSettings} key="payments"/>,
                < Route path="/settings/pricing" component={PricingSettings} key="pricing"/>]
              {/* } */}
              <Redirect to="/settings/profile"/>
            </Switch>

          </div>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/profile/containers/Profile.js